import cores from '~js/solicitacao-cores';

const ICONES_EXTRAS = {
  11: { cor: '#228B22', icone: 'fa fa-file-text-o' },
  12: { cor: '#FF6347', icone: 'fa fa-shopping-cart' },
  19: { cor: '#129ac3', icone: 'fa fa-id-badge' },
  20: { cor: '#FF6347', icone: 'fa fa-credit-card' },
  21: { cor: '#1f6fb2', icone: 'fa fa-ship' },
  22: { cor: '#0a6d4d', icone: 'fa fa-university' },
};

export default function iconeModulo(modulo) {
  if (ICONES_EXTRAS[modulo]) return ICONES_EXTRAS[modulo];
  return cores.find(c => c.id === modulo) || { cor: '#5b6570', icone: 'fa fa-comments-o' };
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/central-mensagens/icones.js